// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const perrserker: PokeData = {
  "id": 863,
  "name": "perrserker",
  "height": 8,
  "weight": 280,
  "base_experience": 154,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "pay-day",
    "scratch",
    "thrash",
    "growl",
    "screech",
    "fury-swipes",
    "slash",
    "swagger",
    "metal-claw",
    "fake-out",
    "taunt",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "iron-head",
    "hone-claws"
  ],
  "moves": [
    "scratch",
    "growl",
    "metal-claw",
    "metal-sound",
    "metal-burst",
    "magnet-pull",
    "steel-beam",
    "smart-strike",
    "behemoth-bash",
    "meteor-mash",
    "metal-rush",
    "crunch",
    "gear-up"
  ],
  "evolution_chain": {
    "id": 22,
    "item": null,
    "species": [
      {
        "name": "meowth",
        "order": 57,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "persian",
        "order": 58,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "perrserker",
        "order": 863,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 52,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 85,
    "ability_power": 187
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
